/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resolveIdentity.defs'
export { main as default } from './resolveIdentity.defs'
